import { API_CLOUD_EZLO_REQUEST_URL } from '../../../constants/URLs.js';
import axios from 'axios';

export const setBounceGetParams = (key) => {
    return {
        call: 'bounce_get',
        params: {
            key,
        },
    };
};

/**
 * Normalizes the token payload `hideMenu` flag to an explicit intent.
 * Returns true for boolean true or the string 'true' (hide the menu),
 * false for boolean false or the string 'false' (show the menu explicitly),
 * and undefined when the field is absent or holds any other/garbage value.
 * In all non-true cases the menu is shown (both false and undefined are falsy).
 * @param {*} value - raw hideMenu value from the bounce payload
 * @return {(true|false|undefined)} the parsed hideMenu intent
 * */
export const parseHideMenu = (value) => {
    if (value === true || value === 'true') {
        return true;
    }

    if (value === false || value === 'false') {
        return false;
    }

    return undefined;
};

export const getUserAuthData = (params) => {
    const { raw } = params.data;
    const rawResponse = JSON.parse(raw);

    return {
        data: {
            path: '',
            Server_Account: rawResponse.Server_Account,
            Server_Account_Alt: rawResponse.Server_Account_Alt,
            Identity: rawResponse.mmsAuth,
            IdentitySignature: rawResponse.mmsAuthSig,
            page: rawResponse.page,
            redirectPath: rawResponse.redirectPath,
            hideMenu: parseHideMenu(rawResponse.hideMenu),
            PK_User: rawResponse.PK_User,
            language: rawResponse.language,
        },
    };
};

export const setBounceGetRequest = (body) => {
    return axios
        .post(API_CLOUD_EZLO_REQUEST_URL(), body, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        })
        .then(({ data }) => {
            if (Object.keys(data.data).length === 0 || data.status === 0) {
                window.location.assign('/');
            } else {
                return data;
            }
        })
        .catch((err) => {
            throw new Error(err);
        });
};
